import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { AppActions } from "../../store/ducks/app";

import KinologyLogo from "../../assets/kinologyIcons/svg/dashBoardLogo.svg";
import Notifications from "../../assets/kinologyIcons/svg/notifications.svg";

import { SuperiorBar, Image } from "./styled";
import { ButtonSave } from "../../styles/global";
import { Button } from "../ui/button";
import { DashBoardActions } from "../../store/ducks/dashboard";
import { Loader2 } from "lucide-react";
import { UserProps } from "../../interfaces/pacientes.interface";
import { ServicosProps } from "../../interfaces/config.interface";

const BarSuperior: React.FC = () => {
	const dispatch = useDispatch();

	const config_servicos: ServicosProps = useSelector(
		(state: any) => state.configs.config_servicos
	);

	const assimetrias_dynalabs: any = useSelector(
		(state: any) => state.dashboard.assimetrias_dynalabs
	);

	const avaliacoes_dynalabs: any = useSelector(
		(state: any) => state.dashboard.avaliacoes_dynalabs
	);

	const cargos_dynalabs = useSelector(
		(state: any) => state.dashboard.cargos
	);

	const protocolos_dynalabs = useSelector(
		(state: any) => state.manage_protocol.protocolos
	);

	const exercicios: any = useSelector(
		(state: any) => state.exercicios.exercicios
	);

	const anotacoes = useSelector(
		(state: any) => state.dashboard.anotacoes_dynalabs
	);

	const pacientes = useSelector((state: any) => state.dashboard.pacientes);

	const user_logado: UserProps = useSelector((state: any) => state.auth.user);


	const [clicado, set_clicado] = useState(false)
	useEffect(() => {
		if (
			protocolos_dynalabs?.length > 0 &&
			// cargos_dynalabs?.length > 0 &&
			assimetrias_dynalabs?.code == 0 &&
			avaliacoes_dynalabs?.code == 0 &&
			exercicios?.length > 0 &&
			anotacoes?.code == 0 &&
			pacientes?.length > 0 &&
			clicado
		) {
			set_clicado(false);
			dispatch(DashBoardActions.set_current_page("dash_dynalabs"));
		}
	}, [
		assimetrias_dynalabs,
		avaliacoes_dynalabs,
		cargos_dynalabs,
		protocolos_dynalabs,
		exercicios,
		anotacoes,
		pacientes
	])

	const realizarChamadas = async () => {
		dispatch(DashBoardActions.search_saved_panels_request());
		dispatch(DashBoardActions.avaliacoes_request())
		dispatch(DashBoardActions.assimetrias_dynalabs_request())
		dispatch(DashBoardActions.cargos_request())
		dispatch(DashBoardActions.protocolos_request())
		dispatch(DashBoardActions.exercices_request())
		dispatch(DashBoardActions.sync_porta_entrada_request());
		dispatch(DashBoardActions.anotacoes_dynalabs_request());
		dispatch(DashBoardActions.gerencias_request());
		dispatch(DashBoardActions.avaliadores_request());
		set_clicado(true);
	};


	return (
		<SuperiorBar>
			<Image src={KinologyLogo} alt="" />
			<div
				style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
			>
				{
					(
						user_logado?.USUARIO_NIVEL == '1' && config_servicos?.SERVICO_DYNALAB == true 
						 //user_logado.USUARIO_EMAIL == "jessica.rodrigues@kinology.com.br"
					) &&
					<Button
						variant="outline"
						className="w-[19.56rem] h-[3rem] border-Blue-K-Principal-100 text-Blue-K-Principal-100 hover:bg-blue-50"
						onClick={realizarChamadas}
					>
						{clicado &&
							<Loader2 className="animate-spin" />
						}
						Acessar dashboard
					</Button>
				}
				<Image
					src={Notifications}
					onClick={() => {
						dispatch(AppActions.set_modal_notificacoes(true));
					}}
					style={{
						width: 25,
						height: 25,
						cursor: "pointer",
						marginLeft: "40px",
					}}
				/>
			</div>
		</SuperiorBar >
	);
};

export default BarSuperior;
